<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="详情"
    width="500px"
  >
    <!-- 头像 -->
    <div class="headPicture">
      <img :src="info.avatar" alt="" />
      <a>王牛牛</a>
    </div>
    <!-- 内容 -->
    <div class="information">
      <p>说明</p>
      <span>附件已发送至您的邮箱</span>
    </div>
    <div class="information">
      <div>
        <p>员工工资</p>
        <span>{{ info.bid_wages }}</span>
      </div>
      <div>
        <p>佣金</p>
        <span>{{ info.bid_commission }}</span>
      </div>
     
    </div>
    <div class="information">
      <p>备注</p>
      <span>{{ info.remarks }}</span>
    </div>
    <div class="requirements">
      <div>
        <p>附件</p>
        <span>{{ info.bid_annex_name }}</span>
      </div>
      <div>
        <p></p>
        <span> 下载</span>
      </div>
    </div>
    <!-- 线 -->
   
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="submit(2)"
        size="mini"
        style="background: #ff4e4e; border: none; color: aliceblue"
        v-if="info.bid_status==0"
        >淘汰</el-button
      >
      <el-button
        @click="submit(1)"
        size="mini"
        style="background: #4d71d9; border: none; color: aliceblue"
        v-if="info.bid_status==0"
        >中标</el-button
      >
    </span>
  </el-dialog>
</template>
  
  <script>
  import { webCrowdBidUpdate } from "@/api/director/package/index";

export default {
  data() {
    return {
      visible: false,
      info:{},
      formData:{
        crowd_id:"",
        bid_id:"",
        bid_status:""
      }
    };
  },

  filters: {
    comSettleTypesFilter(status) {
      const statusMap = {
        1: '日结',
        2: '周结',
        3: '月结',
        4:'完工结',
        5:'入职结'
      }
      return statusMap[status]
    },
    comTypesFilter(status) {
      const statusMap = {
        1: '按人',
        2: '按件',
        3: '总价',
      }
      return statusMap[status]
    }
  },

  beforeDestroy(){
    this.handleClose();
  },

  methods: {
    init(info) {
      this.visible = true;
      this.info=info;
      this.formData.bid_id=info.bid_id;
      this.formData.crowd_id=info.crowd_id;
      //this.initComp();
    },

    handleClose() {
      this.info={};
      this.visible = false;

    },

    
    submit(status) {
      this.formData.bid_status=status;
      webCrowdBidUpdate( this.formData).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.visible=false;
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });

    },
  },
};
</script>
  
  <style lang="scss" scoped>
::v-deep .el-dialog__header {
  display: flex;
  background-color: #f4f6f8;
  border-radius: 10px 10px 0 0;
}
::v-deep .el-dialog--center {
  border-radius: 10px;
}
::v-deep .el-dialog__footer {
    padding-top: 25px;
  display: flex;
  border-top: 2px solid #cccccc;
  justify-content: flex-end;
}
::v-deep .dialog-footer {
  ::v-deep .el-button--primary {
    background-color: #ff4e4e;
  }
}
::v-deep .el-dialog__body{
    padding: 25px 25px 0 25px;
}
.headPicture {
  display: flex;
  align-items: center;
}
.headPicture img {
  margin-right: 17px;
  width: 32px;
  height: 32px;
  border-radius: 16px;
}
.information {
  margin-top: 26px;
  margin-left: 50px;
  p {
    font-size: 11px;
    font-weight: 500;
    color: #acacac;
    margin-bottom: 12px;
  }
  span {
    font-size: 11px;
    font-weight: bold;
    color: #181818;
  }
}

.information:nth-child(3) {
  display: flex;
  div {
    margin-right: 129px;
  }
  div:nth-last-child(1) {
    margin: 0;
  }
}
.requirements {
  display: flex;
  margin-left: 50px;
  margin-top: 26px;
  div {
    margin-right: 21px;
  }
  p {
    height: 11px;
    font-size: 11px;
    font-weight: 500;
    color: #acacac;
    margin-bottom: 12px;
  }
  span {
    font-size: 11px;
    font-weight: bold;
    color: #4d71d9;
  }
  .line {
    div {
      width: 100%;
      height: 2px;
      background-color: #181818;
    }
    height: 2px;
    background-color: #cccccc;
  }
  // div {
  //   width: 81px;
  // }
}
</style>
  